import { Button } from "react-bootstrap";
import { memo, useCallback } from 'react';
import { Redirect } from 'react-router-dom';

import appHistory from "../../app/appHistory";
import { LoginBoxStyled, LoginStyled } from '../Login/components/styled/LoginStyled';
import {
    CreatedAccountIconStyled,
    CreatedAccountStyled,
    CreatedAccountWrapperStyled,
} from "./styled/CreatedAccountsStyled";
import { BinIcon } from "../../components/icon/Icon";
import { isClientMobile } from "../../components/ClientInfo/ClientInfo";
import { LANG_CHOOSER_TYPES, LangChooser } from "../LangChooser";
import { MainHeader } from "../../components/main-header/MainHeader";
import { RouterPaths } from "../../app/appConstants";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { useResponsive } from "../../components/responsive";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const CreatedAccountIcon = memo(({name}) => (
        <CreatedAccountWrapperStyled>
            <CreatedAccountIconStyled>
                <BinIcon name={name} style={{fontSize: '40px'}}/>
            </CreatedAccountIconStyled>
        </CreatedAccountWrapperStyled>
));

const CreatedAccounts = () => {
    const {isSmallMaxWidth} = useResponsive();
    const {getLangPath} = useLangContext();
    const handleButtonClick = useCallback(() => appHistory.push(RouterPaths.mobileAppLinks), []);
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', isSmallMaxWidth);

    if (!isClientMobile) {
        return <Redirect to={RouterPaths.main}/>;
    }
    return (
            <>
                <MainHeader>
                    <LangChooser isHideButtonArrowIcon isHideButtonName type={LANG_CHOOSER_TYPES.slider}
                                 gtmModule="Header"/>
                </MainHeader>
                <LoginStyled>
                    <LoginBoxStyled>
                        <h1 className="mb-3">{getLangPath('welcome.title')}</h1>
                        <p>{getLangPath('welcome.text')}</p>
                        <CreatedAccountStyled className="mt-5">
                            <CreatedAccountIcon name="IcGraduationCap" style={{fill: 'var(--color-black)'}}/>
                            <h3>{getLangPath('welcome.demo_account')}</h3>
                            <p>{getLangPath('welcome.start_demo')}</p>
                        </CreatedAccountStyled>
                        <CreatedAccountStyled className="mt-5 mb-4">
                            <CreatedAccountIcon name="IcCoinStack"/>
                            <h3>{getLangPath('welcome.live_account')}</h3>
                            <p>{getLangPath('welcome.start_live')}</p>
                        </CreatedAccountStyled>
                        <div className="d-grid">
                            <Button
                                    className={'mb-4'}
                                    onClick={handleButtonClick}
                                    size={'lg'}
                                    type={'submit'}
                                    variant={'primary'}
                            >
                                {getLangPath('welcome.start_trading')}
                            </Button>
                        </div>
                    </LoginBoxStyled>
                </LoginStyled>
            </>
    );
};

export default CreatedAccounts;
